import React, { useContext } from 'react';
import { MainContext, Link } from '@blaze-cms/nextjs-components';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import Breadcrumbs from '@blaze-react/breadcrumb';
import { getRecordParents, getSingleEntitySchema } from '../../application/query';
import Wrapper from '../Wrapper';
import { getClassModifiers } from '../../utils';

const Breadcrumb = ({ type, ...otherProps }) => {
  const { isPreview } = useContext(MainContext);
  const { parent } = otherProps;
  const { itemEntity, itemId } = parent;

  const {
    data = {},
    error,
    loading
  } = useQuery(getSingleEntitySchema, {
    variables: { id: itemEntity }
  });

  const { getEntitySchema = {} } = data;
  const { actions: { getPublished, get } = {} } = getEntitySchema;
  const actionKey = isPreview ? get : getPublished || get;

  const { data: parentsData = [], loading: parentsLoading } = useQuery(
    getRecordParents(actionKey),
    {
      variables: { id: itemId },
      skip: !actionKey
    }
  );

  if (loading || parentsLoading) return '';
  if (error) return error.message;
  if (!data) return null;

  const modifiers = getClassModifiers('breadcrumb', otherProps);
  const { recordParents: { name, url, parents = [] } = {} } = parentsData;

  if (url === '/') return '';

  const breadcrumbItems = [
    {
      name,
      url
    },
    ...parents,
    {
      name: 'Home',
      url: '/'
    }
  ];

  return (
    <Wrapper className={type} modifiers={modifiers}>
      <Breadcrumbs>
        {breadcrumbItems.reverse().map(item => (
          <Link key={item.url} href={item.url}>
            {item.name}
          </Link>
        ))}
      </Breadcrumbs>
    </Wrapper>
  );
};

Breadcrumb.propTypes = {
  type: PropTypes.string
};

Breadcrumb.defaultProps = {
  type: 'breadcrumb'
};

export default Breadcrumb;
